import { motion } from 'framer-motion'
import { platformSpecs } from '@/components/home/home-data'
import { blockCard } from '@/lib/ui-classes'

export function PlatformSpecs() {
  return (
    <section className="relative bg-zinc-950 px-4 py-20 sm:px-6">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mx-auto mb-12 max-w-3xl text-center"
        >
          <h2 className="text-3xl font-semibold text-white md:text-4xl">平台能力概览</h2>
          <p className="mt-5 text-lg leading-8 text-zinc-400">
            围绕创作效率、形象一致性与成片质量，平台还沉淀了这些真正影响产出的核心能力。
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {platformSpecs.map(({ icon: Icon, title, desc, value }) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.45 }}
              className={`${blockCard} rounded-3xl p-6 transition-all duration-300 hover:border-[#07F4F2]/25`}
            >
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 flex-none items-center justify-center rounded-2xl border border-white/10 bg-black/35">
                  <Icon className="h-6 w-6 text-[#07F4F2]" />
                </div>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-3">
                    <h3 className="text-xl font-semibold text-white">{title}</h3>
                    <span className="rounded-full border border-[#07F4F2]/20 bg-[#07F4F2]/10 px-3 py-1 text-xs font-medium text-[#C1FAB8]">
                      {value}
                    </span>
                  </div>
                  <p className="mt-3 text-base leading-7 text-zinc-400">{desc}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
